import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IPbxUser, Pbx } from 'voxloud-types/dist/models';

import { AccountService, SessionService } from '../components';
import { Device } from '../model/pbx.class';
import { Session } from '../model/session.class';

@Injectable()
export class PBXService {
  public users: IPbxUser[] = [];
  public pbx: Pbx;

  private session: Session;
  private headers = new HttpHeaders({
    Authorization: 'Bearer ' + this.account.current.token,
    'Voverc-Jwt-Auth': this.account.current.jwtToken,
  });

  constructor(
    private http: HttpClient,
    private account: AccountService,
    private currentSession: SessionService
  ) {
    this.session = this.currentSession.current;
  }

  public getUsers(pbxId: number): Observable<IPbxUser[]> {
    return this.http.get<IPbxUser[]>(`${environment.API_URL}/api/v1/pbxes/${pbxId}/users`, { headers: this.headers });
  }

  public getDevices(pbxId: number, userId: number): Observable<Device[]> {
    return this.http.get<Device[]>(`${environment.API_URL}/api/v1/pbxes/${pbxId}/users/${userId}/csp-devices`, {
      headers: this.headers,
    });
  }

  public setUsers(users: IPbxUser[]): void {
    this.users = [...users];
  }

  public getCachedUsers(): IPbxUser[] {
    return this.users;
  }

  public getPbx(): Observable<Pbx> {
    return this.http.get<Pbx>(`${environment.API_URL}/api/v1/pbxes/${this.session.pbxId}`, { headers: this.headers });
  }

  public setPbx(pbx: Pbx): void {
    this.pbx = pbx;
  }

  public getCachedPbx(): Pbx {
    return this.pbx;
  }
}
